export default __webpack_public_path__ + "static/media/transfer-receive-step2-option2.2ba999eb.png";